import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface VideoEmbedCodeState {
  iframe: string | null;
  script: string | null;
}

export const videoEmbedCodeInitialState: VideoEmbedCodeState = {
  iframe: null,
  script: null,
};

export const embedCodeSlice = createSlice({
  name: 'videoEmbedCode',
  initialState: videoEmbedCodeInitialState,
  reducers: {
    setEmbedCode(state, action: PayloadAction<NonNullable<VideoEmbedCodeState>>) {
      state.iframe = action.payload.iframe;
      state.script = action.payload.script;
    },
  },
});

export const videoEmbedCodeReducer = embedCodeSlice.reducer;

export const { setEmbedCode } = embedCodeSlice.actions;
